import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Heart, MessageCircle, Building2, Calendar, User, Users } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';

const NAV = [
  { to: '/app/discover', label: 'Discover', icon: Heart, testid: 'nav-discover' },
  { to: '/app/matches', label: 'Matches', icon: MessageCircle, testid: 'nav-matches' },
  { to: '/app/businesses', label: 'Businesses', icon: Building2, testid: 'nav-businesses' },
  { to: '/app/events', label: 'Events', icon: Calendar, testid: 'nav-events' },
  { to: '/app/communities', label: 'Communities', icon: Users, testid: 'nav-communities' },
  { to: '/app/profile', label: 'Profile', icon: User, testid: 'nav-profile' },
];

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    window.location.href = '/';
  }

  return (
    <div className="min-h-screen bg-[#FFFCF9] flex flex-col" data-testid="app-layout">
      {/* Header */}
      <header className="bg-white border-b border-[#F4F1DE] sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <button
            onClick={() => navigate('/app/discover')}
            className="flex items-center gap-2"
            data-testid="header-logo-button"
          >
            <div className="w-9 h-9 rounded-lg bg-white border border-[#FFE5DD] flex items-center justify-center shadow-md shadow-[#E07A5F]/20 overflow-hidden">
              <img src="/logo.jpg" alt="AfroConnect" className="w-7 h-7 object-contain" />
            </div>
            <span
              className="text-lg font-serif font-bold text-[#2B2D42] hidden sm:inline"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              AfroConnect
            </span>
          </button>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map(({ to, label, icon: Icon, testid }) => (
              <NavLink
                key={to}
                to={to}
                data-testid={testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                    isActive ? 'bg-[#FFE5DD] text-[#C8553D]' : 'text-[#6D6875] hover:bg-[#F4F1DE]'
                  }`
                }
              >
                <Icon className="w-4 h-4" />
                {label}
              </NavLink>
            ))}
          </nav>

          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="text-xs sm:text-sm font-semibold text-[#C8553D] hover:bg-[#FFE5DD] px-3 py-1.5 rounded-lg transition-colors"
          >
            Log out
          </button>
        </div>
      </header>

      {/* Page content */}
      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav
        data-testid="mobile-bottom-nav"
        className="md:hidden fixed bottom-0 inset-x-0 bg-white border-t border-[#F4F1DE] z-30 shadow-lg"
      >
        <div className="grid grid-cols-6">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid + '-mobile'}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 text-[10px] font-bold transition-colors ${
                  isActive ? 'text-[#C8553D]' : 'text-[#6D6875]'
                }`
              }
            >
              <Icon className="w-5 h-5 mb-1" />
              {label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
